<app-topo></app-topo>

<router-outlet></router-outlet>

<p-toast position="center" [baseZIndex]="10000"></p-toast>
